import React from 'react';
import './App.css';
import './css/mainstyle.css';
import Dashboard from './Pages/Dashboard';
import 'bootstrap/dist/css/bootstrap.min.css';
import LenderList from './Pages/Lender';
import { Route, Routes } from 'react-router-dom';
import Login from './Pages/Loginpage';
import UpdatePassword from './Pages/Updatepassword';
import BorrowerList from './Pages/Borrower';
import ProjectList from './Pages/Projects';
import Projectview from './Pages/Project-view';
import ViewUser from './Pages/Viewuser';
import ProjectStatus from './Pages/Fundproject';
import CreateContract from './Pages/Contract';
import RequestContract from './Pages/RequestContract';
// import CreatorTemplate from './Pages/BluckEmail/CreatorTemplate/CreatorTemplate';


function App() {
  return (
    <React.Fragment>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="lenderlist" element={<LenderList />}></Route>
        <Route path="/borrowerList" element={<BorrowerList />}></Route>
        <Route path="/create-contract" element={<CreateContract />}></Route>
        <Route path="/request-contract" element={<RequestContract />}></Route>
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="/projects" element={<ProjectList />}></Route>
        <Route path="/view-project/:id" element={<Projectview />} />
        <Route path="/view-user/:id" element={<ViewUser />}></Route>
        <Route path="/projectfund-status" element={<ProjectStatus />}></Route>
        {/* <Route path="/create-template" element={<CreatorTemplate />}></Route> */}

      </Routes>
    </React.Fragment >
  );
}

export default App;
